const initialState = {
    tenantsList: [],
  };
  
  export const tenantsReducer = (state = initialState, action) => {
    if (typeof action.execute === "function" && action.type === "tenants")
      return action.execute(state);
    return state;
  };
  